import { memo } from 'react';

function RebalancingIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M5.59698 14.1828L4.49214 6.44886C4.32001 5.24399 5.25493 4.16602 6.47203 4.16602H8.52666C9.74376 4.16602 10.6787 5.24399 10.5066 6.44886L9.40172 14.1828C9.26647 15.1295 8.45568 15.8327 7.49935 15.8327C6.54302 15.8327 5.73223 15.1295 5.59698 14.1828Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path d="M1.66602 10L4.99935 10M18.3327 10L9.99935 10" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default memo(RebalancingIcon);
